<app-area-header
    *ngIf="profilePicture"
    [largeHeadline]="largeHeadline"
    [smallHeadlineTranslationKey]="smallHeadlineTranslationKey"
    [smallHeadlineRaw]="smallHeadlineRaw"
    [smallHeadlineIconPath]="smallHeadlineIconPath"
    [profilePicture]="profilePicture"
    [enablePictureUpload]="tabIndex === 0"
    (pictureSelected)="onPictureSelected($event)"
></app-area-header>
<div class="page-window">
    <div class="d-flex flex-column">
        <div class="d-flex selection-header">
            <div
                id="user-and-login-data-tab"
                [ngClass]="{ dragBox: true, selected: tabIndex === 0 }"
                (click)="onSelectTab(0)"
                [tabIndex]="0"
                (keydown.enter)="onSelectTab(0)"
            >
                <div class="background"></div>
                <div class="tab-text">
                    {{ 'user.userArea.tabs.userAndLoginData' | translate }}
                </div>
            </div>
            <div
                *ngIf="!isOrgBoundUser"
                id="abo-tab"
                [ngClass]="{ dragBox: true, selected: tabIndex === 1 }"
                (click)="onSelectTab(1)"
                [tabIndex]="0"
                (keydown.enter)="onSelectTab(1)"
            >
                <div class="background"></div>
                <div class="tab-text">
                    {{ 'user.userArea.tabs.abo' | translate }}
                </div>
            </div>
            <div
                *ngIf="isUserApiTokenCreator"
                id="api-management-tab"
                [ngClass]="{ dragBox: true, selected: tabIndex === 2 }"
                (click)="onSelectTab(2)"
                [tabIndex]="0"
                (keydown.enter)="onSelectTab(2)"
            >
                <div class="background"></div>
                <div class="tab-text">
                    {{ 'user.userArea.tabs.apiManagement' | translate }}
                </div>
            </div>
            <div
                *ngIf="isUserExperimental"
                id="payment-method-tab"
                [ngClass]="{ dragBox: true, selected: tabIndex === 3 }"
                (click)="onSelectTab(3)"
                [tabIndex]="0"
                (keydown.enter)="onSelectTab(3)"
            >
                <div class="background"></div>
                <div class="tab-text">
                    {{ 'user.userArea.tabs.paymentMethod' | translate }}
                </div>
            </div>
            <div
                *ngIf="isUserExperimental"
                id="bills-tab"
                [ngClass]="{ dragBox: true, selected: tabIndex === 4 }"
                (click)="onSelectTab(4)"
                [tabIndex]="0"
                (keydown.enter)="onSelectTab(4)"
            >
                <div class="background"></div>
                <div class="tab-text">
                    {{ 'user.userArea.tabs.bills' | translate }}
                </div>
            </div>
            <div
                id="credits-tab"
                [ngClass]="{ dragBox: true, selected: tabIndex === 5 }"
                (click)="onSelectTab(5)"
                [tabIndex]="0"
                (keydown.enter)="onSelectTab(5)"
            >
                <div class="background"></div>
                <div class="tab-text">
                    {{ 'user.userArea.tabs.credits' | translate }}
                </div>
            </div>
        </div>
    </div>
    <app-profile-page
        *ngIf="tabIndex === 0"
        [isUserExperimental]="isUserExperimental"
    ></app-profile-page>
    <app-subscriptions-page
        *ngIf="tabIndex === 1 && !isOrgBoundUser"
        context="user"
        [userId]="userId"
        [activeOrganization]="activeOrganization"
    ></app-subscriptions-page>
    <app-api-management *ngIf="tabIndex === 2"></app-api-management>
    <app-credits
        *ngIf="tabIndex === 5"
        [userId]="userId"
        (changeSubscriptionClicked)="onSelectTab(1)"
    >
    </app-credits>
</div>
